import { createFeatureSelector, createSelector } from '@ngrx/store';
import { STATION_FEATURE_KEY, StationState } from './station.reducer';

export const selectStationState = createFeatureSelector<StationState>(STATION_FEATURE_KEY);

export const selectStations = createSelector(selectStationState, (state) => state?.data ?? null);
export const selectStationDetail = createSelector(selectStationState, (state) => state?.detail ?? null);
export const selectStationsTotal = createSelector(selectStationState, (state) => state?.total ?? 0);
export const selectStationsQuery = createSelector(selectStationState, (state) => state?.query ?? null);
export const selectStationComponents = createSelector(selectStationState, (state) => state?.components ?? null);
export const selectStationsLoading = createSelector(selectStationState, (state) => state?.loading ?? false);
export const selectStationsError = createSelector(selectStationState, (state) => state?.error ?? null);
